// extracted by mini-css-extract-plugin
module.exports = {"label":"TextAreaLabel_label__1U38V","required":"TextAreaLabel_required__2OxgR","optional":"TextAreaLabel_optional__2DGRf"};